<div class="row">
  <aside class="col-3 col-xs-12"></aside>

  <div class="col-9 col-xs-12">
    <!-- Invoices -->
    <div class="row mt-4 mx-3 mx-lg-0" *ngIf="paymentList.length > 0">
      <div class="col-md-12">
        <table
          aria-describedby="invoicesTable"
          id="invoicesTable"
          class="payments-table c-table c-table--branded">
          <thead>
            <tr>
              <th
                scope="col"
                class="col-width"
                (click)="sortColumn($event, 'docNo', paymentList, 'normal')">
                {{ 'makeAPayment.invoice#' | cxTranslate }}
                <i class="my-icon fas fa-caret-down"></i>
              </th>
              <th
                scope="col"
                class="col-width"
                (click)="sortColumn($event, 'blineDate', paymentList, 'Date')">
                {{ 'makeAPayment.invoice_date' | cxTranslate }}
                <i class="my-icon fas fa-caret-down"></i>
              </th>
              <th
                scope="col"
                class="col-width"
                (click)="sortColumn($event, 'dueDate', paymentList, 'Date')">
                {{ 'makeAPayment.due_date' | cxTranslate }}
                <i class="my-icon fas fa-caret-up"></i>
              </th>
              <th
                scope="col"
                class="col-width"
                (click)="sortColumn($event, 'amount', paymentList, 'Number')">
                {{ 'makeAPayment.invoice_balance' | cxTranslate }}
                <i class="my-icon fas fa-caret-down"></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of paymentList; let i = index">
              <td class="pay">
                <span class="font-bold d-md-none"
                  >{{ 'makeAPayment.invoice#' | cxTranslate }}:
                </span>
                <a
                  *ngIf="
                    data.docType === 'RV' ||
                    data.docType === 'RD' ||
                    data?.docType === 'RF'
                  "
                  href="javascript: void(0);"
                  class="underline"
                  (click)="downloadPdf(data.refDocNo, 'P08')">
                  {{ data.refDocNo }}
                </a>

                <a
                  *ngIf="
                    data.docType === 'DZ' && data.allocNmbr.startsWith('7')
                  "
                  href="javascript: void(0);"
                  class="underline"
                  (click)="downloadPdf(data.allocNmbr, 'P08')">
                  {{ data.allocNmbr }}
                </a>
                <span
                  *ngIf="
                    data.docType === 'DR' ||
                    data.docType === 'DG' ||
                    data?.docType === 'DY'
                  ">
                  {{ data.refDocNo }}
                </span>
                <span *ngIf="data.docType === 'YR'">
                  {{ data.refhdr }}
                </span>
              </td>
              <td class="pay">
                <span class="font-bold d-md-none"
                  >{{ 'makeAPayment.invoice_date' | cxTranslate }}: </span
                >{{ data.blineDate }}
              </td>
              <td class="pay">
                <span class="font-bold d-md-none"
                  >{{ 'makeAPayment.due_date' | cxTranslate }}:
                </span>
                <span
                  [ngClass]="
                    !!data.dueDate && dateComparison(data.dueDate) ? 'red' : ''
                  "
                  >{{ data.dueDate }}
                  <ng-template #popSaveContent>
                    <span class="popover-content">{{
                      'makeAPayment.past_due_date' | cxTranslate
                    }}</span>
                  </ng-template>
                  <span
                    [ngbPopover]="popSaveContent"
                    triggers="manual"
                    #p1="ngbPopover"
                    placement="top"
                    (click)="toggle(p1)"
                    container="body"
                    popoverClass="popover-links-invoice"
                    *ngIf="!!data.dueDate && dateComparison(data.dueDate)">
                    <img
                      src="assets/icons/warning_red.png"
                      alt="warningIcon"
                      class="warningIconEvent" />
                  </span>
                </span>
              </td>
              <td class="pay">
                <span class="font-bold d-md-none">
                  {{ 'makeAPayment.invoice_balance' | cxTranslate }}:
                </span>
                {{ data.amount | localCurrency }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- No Invoices -->
    <section
      class="row credits-section mx-3 mx-lg-0 mb-4"
      *ngIf="!paymentList || paymentList.length === 0">
      <div class="col-md-12">
        <h3 class="font-bold">
          {{ 'makeAPayment.no_open_invoices' | cxTranslate }}
        </h3>
      </div>
    </section>
  </div>
</div>
